import { initCookieBannerUI } from './components/ui.js';
import { initCookieManager } from './components/cookie-manager.js';

function initCookieBanner(config) {

	initCookieBannerUI();
	initCookieManager(config);
}

export { initCookieBanner };